/* THIS FILE IS AUTO-GENERATED BY LABEL SERVICES */
const fr_CA = {
  BACK_TO_PAGES: 'Retour aux pages',
  NO_PREFERENCES_FOUND: 'Aucune préférence trouvée',
  CONFIRMATION: 'Confirmation',
  EXPORT: 'Exporter',
  ALL_CONDITIONS: 'Toutes les conditions',
  CLOSE: 'Fermer',
  CERTIFIED: 'Certifié ',
  YEAR: 'Année',
  PAGE_PATH_INVALID: "Le chemin d'accès de page n'est pas valide pour votre nouvelle page. Veuillez modifier votre URL. ",
  CONTENT_TYPE: 'Type de contenu',
  SITEMAP_END_DATE: 'Retirer du plan de site',
  NONE: 'Aucun',
  PATH_ERROR_MUST_END_IN_HTM: 'Le chemin doit se terminer par .htm',
  PAGE_SELECTED: '{count} Page sélectionnée',
  SITECONTENT_NO_HISTORY: 'Sin Historial',
  FILTER_TYPE_CUSTOM_TOOLTIP: 'Pages créées spécifiquement pour cette concession. Elles sont uniques à votre site et entièrement modifiables. ',
  SEARCH: 'Rechercher',
  PAGE_ALIAS: 'Pseudonyme de page',
  SELECT_A_CONDITION: 'Sélectionnez une condition',
  SITEMAP_MANAGE_PAGES: 'Gérer les pages',
  SITEMAP_PAGES: 'Pages',
  PAGE_ID: 'ID de la page',
  DELETE_PAGE_CONFIRM: 'Êtes-vous sûr de vouloir supprimer cette page ? ',
  FILTERED_PAGES_COUNT: '{filtered} sur {total} pages',
  NO_INDEX_TOOLTIP: "Empêche les moteurs de recherche d'indexer cette page. Décochez cette case pour autoriser à nouveau l'indexation. ",
  SELECT_PAGE_ID: "Sélectionner l'ID de la page",
  ARE_YOU_SURE_YOU_WANT_TO_RESTORE_THIS_REVISION_NOTE: 'Remarque : Ces modifications ne seront pas enregistrées immédiatement. Cliquez sur "Enregistrer" pour appliquer les modifications à votre site en ligne. ',
  BATCH_LIMIT_CONFIRM: 'Retournez en arrière et mettez à jour vos sélections',
  CONDITION: 'Condition',
  REMOVE_PAGES: 'Supprimer les pages',
  NO_ITEMS_MATCH: 'Aucun article ne correspond',
  VIEW_LINK: 'Voir le lien',
  PICK_A_GRADIENT: 'Choisissez un dégradé ',
  FILTER_TYPE_CUSTOM: 'Coutume',
  SITEMAP_END_DATE_INVALID: 'La date de fin doit être ultérieure à la date de début. ',
  DISCARD_CHANGES: 'Éliminer les modifications',
  SELECT_MAKE_TO_FILTER_BY_MODELS: 'Sélectionnez une marque pour filtrer par modèles',
  DRAFT_OF_PAGE_EXISTS_ALREADY: 'Page de brouillon déjà existante',
  ERROR_LOADING_SITEMAP: 'Erreur lors du chargement du plan du site : {message} ',
  PICK_A_COLOR: 'Choisissez une couleur',
  BATCH_UPDATE_LIMIT_MSG_3: 'Veuillez réduire votre sélection à {batchUpdateLimit} pages ou moins, puis réessayer. ',
  DELETE: 'Effacer',
  PAGE_PATH: 'Chemin de la page',
  GO_TO_DRAFT: 'Aller au brouillon',
  NO_INDEX: 'Aucun index',
  NO_FOLLOW: 'Pas de suivi',
  SAVE: 'Enregistrer',
  CLEAR_FILTERS: 'Effacer les filtres',
  SHOW_IN_HTML_SITEMAP: 'Afficher sur le plan de site HTML',
  YES_RESTORE_THIS_REVISION: 'Yes',
  SITECONTENT_HISTORY: 'Historique du contenu',
  MODEL: 'Modèle',
  DELETE_PAGES_WARNING: 'La suppression de ces pages peut entraîner des erreurs 404 si elles figurent dans le menu de navigation de votre site. Pour éviter les liens invalides, supprimez les éléments correspondants de votre menu de navigation avant de poursuivre. ',
  LINK_TO_DVS_WEB_COMPARISON: 'Lien vers la comparaison dvs-web avec la révision actuelle',
  INHERITED_DISTRIBUTED_PAGE_TOOLTIP: "Cette page est {src} et provient d'un site parent",
  ARE_YOU_SURE_YOU_WANT_TO_RESTORE_THIS_REVISION: 'Êtes-vous sûr de vouloir charger cette révision ? ',
  CANCEL: 'Annuler',
  NO_RESTORE_THIS_REVISION: 'No',
  STAY: 'Rester',
  NEW: 'Neuf',
  NO_SITEMAP_DATA: 'Aucune donnée de plan de site',
  PAGE_ID_MISSING_ERROR: "Cette page n'a pas d'identifiant de page correspondant et renverra une erreur 404",
  ERROR_MESSAGE_PAGE_DETAIL: 'Impossible de charger les détails de la page. Veuillez réessayer. ',
  PAGES_SELECTED: '{count} Pages sélectionnées',
  FILTER_TYPE_SITE_DEFAULT_TOOLTIP: 'Pages incluses par défaut dans votre modèle de site web. Elles sont préconfigurées et intégrées à chaque installation de site. ',
  SITEMAP_START_DATE: 'Ajouter au plan de site',
  FILTER_TYPE_PROGRAM_TOOLTIP: 'Contenu distribué géré par un équipementier ou un programme partenaire. Les modifications peuvent être limitées ou écrasées par les mises à jour du programme. ',
  BODY_STYLE_LOCALIZATION_WARNING: 'Les styles de corps sont localisés et peuvent ne renvoyer aucun résultat pour les sites multilingues. ',
  USED: "D'occasion",
  DELETE_PAGE_WARNING: "La suppression de cette page entraînera une erreur 404 si elle figure actuellement dans le menu de navigation de votre site. Pour éviter les liens invalides, supprimez l'élément correspondant de votre menu de navigation. ",
  DELETE_PAGES_CONFIRM: 'Êtes-vous sûr de vouloir supprimer les pages suivantes ? ',
  DONE: 'Terminé ',
  SHOW_IN_HTML_SITEMAP_TOOLTIP: "Incluez cette page dans le sitemap HTML de votre site pour faciliter son indexation par les visiteurs et les moteurs de recherche. Décochez cette case pour l'exclure. ",
  FILTER_TYPE_PROGRAM: 'Programme',
  NO_FOLLOW_TOOLTIP: 'Empêche les moteurs de recherche de suivre les liens de cette page. Décochez cette case pour autoriser les moteurs de recherche à suivre les liens normalement. ',
  BATCH_UPDATE_LIMIT_MSG_2: 'Pour éviter toute perte accidentelle de données et gérer les risques, les mises à jour groupées sont limitées à {batchUpdateLimit} pages à la fois. ',
  BATCH_UPDATE_LIMIT_MSG_1: 'Vous avez sélectionné plus de {batchUpdateLimit} pages. ',
  BATCH_DELETE_LIMIT_MSG_2: 'Pour éviter toute perte accidentelle de données et gérer les risques, les suppressions en masse sont limitées à {batchDeleteLimit} pages à la fois. ',
  BATCH_DELETE_LIMIT_MSG_1: 'Vous avez sélectionné plus de {batchDeleteLimit} pages. ',
  BATCH_DELETE_LIMIT_MSG_3: 'Veuillez réduire votre sélection à {batchDeleteLimit} pages ou moins, puis réessayer. ',
  VIEW_MORE: 'Afficher davantage',
  NO_MATCHING_RESULTS: 'Aucun résultat correspondant',
  BATCH_UPDATE_LIMIT_TITLE: 'Limite de mise à jour groupée atteinte',
  MAKE: 'Marque',
  BODYSTYLE: 'Carrosserie',
  PAGE_ALIAS_INVALID: 'Pseudonyme de page non valide pour votre nouvelle page. Ce pseudonyme existe déjà. ',
  BATCH_EDIT_PAGE_DETAILS: 'Détails de la page de modification par lots',
  CLEAR_SEARCH_AND_FILTERS: 'Effacer la recherche et les filtres',
  OK: 'OK',
  SHOW_IN_XML_SITEMAP_TOOLTIP: "Incluez cette page dans le sitemap XML de votre site, ce qui aidera les moteurs de recherche à la découvrir et à l'indexer. Décochez cette case pour l'exclure. ",
  PATH_ERROR_BEGIN_WITH: "Le chemin doit commencer par '/' ou 'http:' ",
  OR: 'ou',
  PATH_ERROR_MUST_NOT_CONTAIN_PLUS: 'Le chemin ne doit pas contenir "+". ',
  UNSAVED_CHANGES: 'Changements non sauvegardés',
  SHOW_IN_XML_SITEMAP: 'Afficher sur le plan de site XML',
  SITEMAP_DELETE: 'Supprimer ({count}) ',
  BATCH_DELETE_LIMIT_TITLE: 'Limite de suppression en masse atteinte',
  PAGE_DETAILS: 'Détails de la page',
  UNSAVED_CHANGES_MESSAGE: 'Vous avez des modifications non enregistrées. Si vous quittez maintenant, ces modifications seront perdues. ',
  DRAFT_OF_PAGE_EXISTS_ALREADY_DESCRIPTION: 'Il y a des changements dans un brouillon non publié de la page active. Veuillez publier ou supprimer la page brouillon avant de continuer. ',
  SITEMAP_START_DATE_REQUIRED: 'Ce champ est obligatoire',
  FILTER_TYPE_SITE_DEFAULT: 'Site par défaut',
  REMOVE_PAGE: 'Supprimer la page'
}
export default fr_CA;